export default __webpack_public_path__ + "static/media/all.53f3ba84.png";